<template>
    <div class="content-item">
        <h1 class="title text-shadow">Consejos adicionales</h1>
        <div class="row video-content">
            <div class="item col-xs-12 col-md-4 col-lg-2">
                <div class="card" @click="showVideo(1)">
                    <div class="card-content"><img src="@/assets/imgs/vide1.png" alt=""></div>
                    <div class="card-footer">
                        <p class="title">Causas de accidentes</p>
                    </div>
                </div>
            </div>
            <div class="item col-xs-12 col-md-4 col-lg-2">
                <div class="card" @click="showVideo(2)">
                    <div class="card-content"><img src="@/assets/imgs/vide2.png" alt=""></div>
                    <div class="card-footer">
                        <p class="title">Consejos</p>
                    </div>
                </div>
            </div>
            <div class="item col-xs-12 col-md-4 col-lg-2">
                <div class="card" @click="showVideo(3)">
                    <div class="card-content"><img src="@/assets/imgs/vide3.png" alt=""></div>
                    <div class="card-footer">
                        <p class="title">Datos duros</p>
                    </div>
                </div>
            </div>
            <div class="item col-xs-12 col-md-4 col-lg-2">
                <div class="card" @click="showVideo(4)">
                    <div class="card-content"><img src="@/assets/imgs/vide4.png" alt=""></div>
                    <div class="card-footer">
                        <p class="title">Súper Héroe</p>
                    </div>
                </div>
            </div>
            <div class="item col-xs-12 col-md-4 col-lg-2">
                <div class="card" @click="showVideo(5)">
                    <div class="card-content"><img src="@/assets/imgs/vide5.png" alt=""></div>
                    <div class="card-footer">
                        <p class="title">Señales</p>
                    </div>
                </div>
            </div>
            <div class="item col-xs-12 col-md-4 col-lg-2">
                <div class="card" @click="showVideo(6)">
                    <div class="card-content"><img src="@/assets/imgs/vide6.png" alt=""></div>
                    <div class="card-footer">
                        <p class="title">Torero</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="carousel">
            <carousel :perPage="1" :paginationPadding="2">
                <slide>
                    <div class="card">
                        <div class="card-content"><img src="@/assets/imgs/vide1.png" alt="" @click="showVideo(1)"></div>
                        <div class="card-footer">
                            <p class="title">Causas de accidentes</p>
                        </div>
                    </div>
                </slide>
                <slide>
                    <div class="card">
                        <div class="card-content"><img src="@/assets/imgs/vide2.png" alt="" @click="showVideo(2)"></div>
                        <div class="card-footer">
                            <p class="title">Consejos</p>
                        </div>
                    </div>
                </slide>
                <slide>
                    <div class="card">
                        <div class="card-content"><img src="@/assets/imgs/vide3.png" alt="" @click="showVideo(3)"></div>
                        <div class="card-footer">
                            <p class="title">Datos duros</p>
                        </div>
                    </div>
                </slide>
                <slide>
                    <div class="card">
                        <div class="card-content"><img src="@/assets/imgs/vide4.png" alt="" @click="showVideo(4)"></div>
                        <div class="card-footer">
                            <p class="title">Súper Héroe</p>
                        </div>
                    </div>
                </slide>
                <slide>
                    <div class="card">
                        <div class="card-content"><img src="@/assets/imgs/vide5.png" alt="" @click="showVideo(5)"></div>
                        <div class="card-footer">
                            <p class="title">Señales</p>
                        </div>
                    </div>
                </slide>
                <slide>
                    <div class="card">
                        <div class="card-content"><img src="@/assets/imgs/vide6.png" alt="" @click="showVideo(6)"></div>
                        <div class="card-footer">
                            <p class="title">Torero</p>
                        </div>
                    </div>
                </slide>
            </carousel>
        </div>

        <video-component v-if="showVideoForm" :video="video" @close="toggleVideoForm"></video-component>
    </div>
</template>

<script>

    import VideoComponent from '@/components/VideoComponent'
    import {Carousel, Slide} from 'vue-carousel'

    export default {
        name: "consejos-adicionales",
        components: {
            VideoComponent,
            Carousel,
            Slide
        },
        data() {
            return {
                showVideoForm: false,
                video: 0
            }
        },
        methods: {
            toggleVideoForm() {
                this.showVideoForm = !this.showVideoForm
            },
            showVideo(number) {
                this.video = number
                this.toggleVideoForm()
            }
        }
    };
</script>

<style lang="sass" scoped>
    .content-item
        left: 0
        @media screen and (min-width: 48em)
            position: absolute
            left: 50px
            width: 90%

        .title
            color: white
            text-align: center
            font-size: 4em
            font-weight: bold
            margin-top: 15px
            margin-bottom: 15px
            @media only screen and (max-width: 64em)
                font-size: 3em
                text-overflow: ellipsis
                overflow: hidden
                width: 100%
            @media only screen and (max-width: 320px)
                font-size: 2em
        .video-content
            display: none
            @media screen and (min-width: 48em)
                margin-top: 100px
            @media screen and (min-width: 64em)
                display: flex
        .card
            width: 100%
            border-radius: 10px
            margin-bottom: 15px
            cursor: pointer
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)
            transition: all 0.3s cubic-bezier(.25, .8, .25, 1)
            &:hover
                box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22)

            .card-content
                width: 100%
                height: 100px
                @media only screen and (max-width: 64em)
                    height: 50px
                @media only screen and (max-width: 64em)
                    height: 80px
                img
                    width: 100%
                    height: 100%

            .card-footer
                background-color: black
                padding: .5em 1px
                width: 100%
                box-sizing: border-box
                .title
                    font-size: 1.3em
                    margin: 0
                    text-overflow: ellipsis
                    width: 100%
                    white-space: nowrap
                    overflow: hidden

        .carousel
            padding: 0 1.5em
            @media screen and (min-width: 64em)
                display: none
            .card
                .card-content
                    height: auto

</style>
